import { RouteTo } from './route-to.model';

export interface ConsumerRedirectionConfig {
    email?: string;
    orgId?: string;
    apiUrl?: string;
    routeTo?: RouteTo;
}
